import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Col, Row, Container, Label, ModalFooter } from 'reactstrap';

import './AvisoSelecionarTodas.scss';

class AvisoSelecionarTodas extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			step: 'Default',
      intQuantidade: 0,
			activeIndex: 0,
		};
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true});
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

  selectAll = () => {
    this.props.onAccept();
    this.closeModal();
  };

	renderModal() {
		return (
			<Modal
				id="modal-aviso-selecionar-todas-guias"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.handleModalClosed}
        intQuantidade={this.state.intQuantidade}
				backdrop="static">
        <ModalHeader style={{ background: "#31597B", color: "#FFF" }}>
          Atenção!
        </ModalHeader>
        <ModalBody>
          <div className="formField formField--fit" style={{width:"100%", textAlign: "center"}}>
            <Label style={{ fontSize: "18px" }}>
                Será selecionada {this.props.intQuantidade} guias. Deseja continuar?
            </Label>
          </div>
				</ModalBody>
        <ModalFooter>
          <Container>
            <Row className="justify-content-end">
              <Col xs="auto">
                <Button color="info" onClick={() => this.closeModal()}>
                  Fechar
                </Button>
              </Col>
              <Col xs="auto">
                <Button color="primary" onClick={() => this.selectAll()}>
                  Continuar
                </Button>
              </Col>
            </Row>
          </Container>
        </ModalFooter>
			</Modal>
		);
	}

	render = () => this.renderModal();
}

export default AvisoSelecionarTodas;
